import { inject } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'
import { impression, action } from '@/utils/gtm'

const useMpm = () => {
  const getVisible = (target) => {
    return new Promise((resolve) => {
      const { stop } = useIntersectionObserver(target, ([{ isIntersecting }]) => {
        resolve(isIntersecting)
        stop()
      })
    })
  }

  const layerData = inject('layerData')

  const mpmImpression = (res) => {
    impression({
      ...layerData.value,
      // eventID: 'o002',
      eventID: 'impression_mpm_data',
      page_title: `${res?.category_name || ''}_impression`,
      eventLabel: `${res?.category_name || ''}_impression`,
      screen_class: res?.title || '',
      eventCategoy: 'main_category',
      screenLabel: res?.link || ''
    })
  }

  const mpmTracking = (item, type = '', isurl = true) => {
    if (!isurl) return
    action({
      ...layerData.value,
      // eventID: 'B012',
      eventID: 'impression_mpm_data',
      page_title: `${item.title || ''}_mpm`,
      screen_class: item.title || '',
      eventCategory: 'main_category',
      eventLabel: `${item.title || ''}_mpm`,
      screenLabel: item.jump_param || item.link || '',
      listName: type
    })
  }

  return { layerData, mpmImpression, mpmTracking, getVisible }
}

export default useMpm
